var map = {
	"./coffee_hero_desktop.jpg": 656,
	"./coffee_hero_mobile.jpg": 657,
	"./coffee_hero_tablet.jpg": 658,
	"./icons/offline-icon.png": 659,
	"./icons/playBtn.svg": 158,
	"./icons/replayBtn.svg": 159
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 655;